import { NotificationCenter } from '@/components/notifications'

export function NotificationButton() {
  return (
    <NotificationCenter className="transition-tonal h-9 w-9 rounded-lg duration-200 hover:bg-muted/50" />
  )
}
